export default __webpack_public_path__ + "static/media/reverseManager.fda13a2b.svg";